<nb-card class="dialog-card">
  <nb-card-header>
    {{ "pages.dozent.participants.selectMoodleCourses" | translate }}
  </nb-card-header>
  <nb-card-body>
    <app-page-loader *ngIf="loading"></app-page-loader>

    <div *ngIf="!loading && courses.length === 0" class="empty-msg">
      {{ "pages.dozent.participants.noMoodleCourses" | translate }}
    </div>

    <div *ngIf="!loading && courses.length > 0">
      <div class="select-all">
        <nb-checkbox
          [checked]="allSelected"
          [disabled]="selectableCourses.length === 0"
          (checkedChange)="toggleAll()"
        >
          {{ "pages.dozent.participants.selectAll" | translate }}
          ({{ selectableCourses.length }})
        </nb-checkbox>
      </div>

      <div class="course-list">
        <div
          *ngFor="let mc of courses"
          class="course-item"
          [class.selected]="selectedCourses.has(courseKey(mc))"
          [class.disabled]="isCourseDisabled(mc)"
          [nbTooltip]="isCourseDisabled(mc) ? getCourseDisabledHint(mc) : ''"
          [nbTooltipDisabled]="!isCourseDisabled(mc)"
          nbTooltipPlacement="top"
          (click)="toggleCourse(mc)"
        >
          <nb-checkbox
            [checked]="selectedCourses.has(courseKey(mc))"
            [disabled]="isCourseDisabled(mc)"
            (checkedChange)="toggleCourse(mc)"
            (click)="$event.stopPropagation()"
          ></nb-checkbox>
          <div class="course-info">
            <span class="course-name">{{ mc.fullname }}</span>
            <span class="course-short" *ngIf="mc.shortname">{{ mc.shortname }}</span>
            <span class="course-disabled-hint" *ngIf="isCourseDisabled(mc)">
              {{ getCourseDisabledHint(mc) }}
            </span>
          </div>
          <div class="course-participants">
            <nb-icon icon="people-outline"></nb-icon>
            <span>{{ mc.participant_count ?? 0 }}</span>
          </div>
        </div>
      </div>
      <app-pagination
        *ngIf="courseTotal > coursePageSize"
        [totalItems]="courseTotal"
        [itemsPerPage]="coursePageSize"
        [currentPage]="coursePage"
        [pageSizeOptions]="pageSizeOptions"
        (pageChanged)="onCoursePageChange($event)"
        (itemsPerPageChange)="onCoursePageSizeChange($event)"
      ></app-pagination>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost size="small" (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      size="small"
      (click)="startImport()"
      [disabled]="selectedCourses.size === 0 || importing"
    >
      <nb-icon *ngIf="importing" icon="loader-outline" class="spin"></nb-icon>
      {{ "pages.dozent.participants.importSelected" | translate }}
      <span *ngIf="selectedCourses.size > 0">({{ selectedCourses.size }})</span>
    </button>
  </nb-card-footer>
</nb-card>
